<template>
  <BasePopup
    :visible="v3PopupState.scoreDetailPopupState"
    :mask-closable="true"
    :show-close-btn="true"
    :show-confirm-btn="false"
    popup-class="score-detail-popup"
    @close="handleClose"
  >
    <div class="v3-popup-content-title"></div>
    <div class="v3-popup-content-content">
      <div class="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>項目</th>
              <th>積分變化</th>
              <th>時間</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in scoreLogList" :key="index">
              <td>{{ item.SOURCE_DESC }}</td>
              <td>{{ formatQuantity(item.QUANTITY) }}</td>
              <td>{{ item.CREATE_TIME }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="v3-popup-content-footer">
      <div
        class="page-pre"
        :class="{ un: page <= 1 }"
        @click="handlePrevPage"
      ></div>
      <template v-for="(pageNum, index) in displayPages" :key="index">
        <div v-if="pageNum === '...'" class="page-num">...</div>
        <div
          v-else
          class="page-num"
          :class="{ active: pageNum === page }"
          @click="handlePageClick(pageNum)"
        >
          {{ pageNum }}
        </div>
      </template>
      <div
        class="page-next"
        :class="{ un: page >= totalPages }"
        @click="handleNextPage"
      ></div>
    </div>
  </BasePopup>
</template>

<script setup>
import { inject, reactive, watch } from "vue";
import { point } from "@/utils";
import BasePopup from "./BasePopup.vue";
import useScoreDetail from "@/hooks/useScoreDetail";

const v3PopupState = inject("v3PopupState", reactive({}));
const showCurErrorTips = inject("showCurErrorTips", () => {});
const isLogin = inject("isLogin");

// 使用积分明细 hook
const {
  page,
  scoreLogList,
  totalPages,
  displayPages,
  switchPage,
  initScoreList,
  resetScoreList,
} = useScoreDetail(showCurErrorTips, isLogin);

// 监听弹窗状态，打开时才请求数据
watch(
  () => v3PopupState.scoreDetailPopupState,
  async (value) => {
    console.log('积分明细弹窗状态变化:', value);
    if (value) {
      // 弹窗打开时打点上报并请求数据
      point({
        eventName: 'show_popup',
        eventType: '积分明细弹窗'
      });
      await initScoreList();
    } else {
      // 弹窗关闭时重置数据
      console.log('积分明细弹窗关闭，重置数据');
      resetScoreList();
    }
  },
  { immediate: false }
);

// 关闭弹窗
const handleClose = () => {
  v3PopupState.scoreDetailPopupState = false;
};

// 格式化积分变化显示
const formatQuantity = (quantity) => {
  const str = String(quantity);
  // 如果以 + 或 - 开头，直接返回
  if (str.startsWith('+') || str.startsWith('-')) {
    return str;
  }
  // 否则添加 +
  return '+' + str;
};

// 上一页
const handlePrevPage = () => {
  if (page.value > 1) {
    switchPage(page.value - 1);
  }
};

// 下一页
const handleNextPage = () => {
  if (page.value < totalPages.value) {
    switchPage(page.value + 1);
  }
};

// 点击页码
const handlePageClick = (pageNum) => {
  if (pageNum !== page.value && pageNum !== "...") {
    switchPage(pageNum);
  }
};
</script>

<style scoped lang="less">
</style>
